import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DistrictService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any[]>('district');
  }
  
  getAllTurkey() {
    return this.apiService.get<any[]>('district/district-list-turkey');
  }

  getAllByCityId(cityId: number | string) {
    return new Promise<{ label: string; value: number }[]>((resolve) => {
      this.getAll().subscribe((res) => {
        const cityTowns = res
          .filter((r) => r.city?.id === Number(cityId))
          .map((i) => ({
            label: i.name,
            value: i.id,
          }));
        resolve(cityTowns); // Return the data here after the subscription completes
      });
    });
  }

  getAllByCityName(name: string) {
    return new Promise<{ label: string; value: number }[]>((resolve) => {
      this.getAll().subscribe((res) => {
        const cityTowns = res
          .filter((r) => r.city?.name.toLocaleLowerCase() === name.toLocaleLowerCase())
          .map((i) => ({
            label: i.name,
            value: i.id,
          }));
        resolve(cityTowns); // Return the data here after the subscription completes
      });
    });
  }

  getById(id: number | string) {
    return this.apiService.get<any[]>(`district/${id}`);
  }

  update(data: any) {
    return this.apiService.put<any[]>(`district/update`);
  }

  delete(id: number | string) {
    return this.apiService.delete(`district/delete/${id}`);
  }
}
